import { render, staticRenderFns } from "./QuestionManage.vue?vue&type=template&id=715ee748&scoped=true&"
import script from "./QuestionManage.vue?vue&type=script&lang=js&"
export * from "./QuestionManage.vue?vue&type=script&lang=js&"
import style0 from "./QuestionManage.vue?vue&type=style&index=0&id=715ee748&prod&lang=scss&scoped=true&"
import style1 from "./QuestionManage.vue?vue&type=style&index=1&id=715ee748&prod&scoped=true&lang=css&"
import style2 from "./QuestionManage.vue?vue&type=style&index=2&id=715ee748&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715ee748",
  null
  
)

export default component.exports